import axios from "axios";
import Auth from "../../lib/middleware/auth";
import API_MAP from "../../services/uri";
import BASE_URL from "../api";
import { WEDDING_FAILED, WEDDING_PASSED } from "../types";
import { viewUserProfile } from "./authentication";
import errorDispatcher from "./errorDispatcher";
import errorHandler from "./errorHandler";

// useSelector / types
const setWeddingUrl = (action) => {
	return { type: "WEDDING_URLS", payload: action };
};

export const setCoupleData = (action) => {
	return {
		type: "WEDDING_CREATE",
		payload: action,
	};
};
const setTimezone = (action) => {
	return { type: "TIMEZONE", payload: action };
};

export const fetchCoupleData = async () => {
	try {
		const response = await axios.get(`${BASE_URL}/weddings/view`);
		const { hasError } = response.data;
		if (hasError) {
			// console.log("Get coupple data res =====> \n", response);
			return;
		}
		Auth.setCouple(response.data.data);
		return response.data;
	} catch (error) {
		console.log("fetch wedding couple data", error);
	}
};

export const getTimezone = () => async (dispatch) => {
	try {
		const response = await axios.get(`${BASE_URL}/weddings/timezones-list`);
		const { hasError } = response.data;
		if (hasError) {
			console.log(response);
			return errorDispatcher(
				response.data.errors,
				dispatch,
				WEDDING_FAILED
			);
		} else {
			return dispatch(setTimezone(response.data.data.timezones));
		}
	} catch (error) {
		console.log("Get wedding url=====>", error);
		return errorDispatcher(error, dispatch, WEDDING_FAILED);
	}
};

export const createWedding = async (credentials) => {
	try {
		const response = await axios.post(
			`${BASE_URL}/weddings/create`,
			credentials
		);
		const { hasError } = response.data;
		if (hasError) {
			console.log(response);
			return errorHandler(response.data.errors);
		} else {
			return response.data;
		}
	} catch (error) {
		return errorHandler(error);
	}
};

export const checkUrl = async (credentials) => {
	try {
		const response = await axios.get(
			`${BASE_URL}/weddings/check-url?url=${credentials}`
		);
		const { hasError } = response.data;
		if (hasError) {
			console.log(response);
			return errorHandler(response.data.errors);
		} else {
			return response;
		}
	} catch (error) {
		console.log("Get unique url=====>", error);
		return errorHandler(error);
	}
};

export const fetchWeddingUrls = (credentials) => async (dispatch) => {
	const { brideFirstname, groomFirstname } = credentials;
	try {
		const response = await axios.get(
			`${BASE_URL}/weddings/available-urls?brideFirstname=${brideFirstname}&groomFirstname=${groomFirstname}`
		);
		const { hasError } = response.data;
		if (hasError) {
			console.log(response);
			return errorDispatcher(
				response.data.errors,
				dispatch,
				WEDDING_PASSED
			);
		} else {
			return dispatch(setWeddingUrl(response.data.data));
		}
	} catch (error) {
		console.log("Get wedding url=====>", error);
		return errorDispatcher(error, dispatch, WEDDING_FAILED);
	}
};

export const switchExperience = async (credentials) => {
	const response = await axios.put(
		`${BASE_URL}/users/settings/switch-experience`,
		credentials
	);
	// console.log(credentials, "credentials wedding");
	const { hasError } = response.data;
	if (hasError) {
		return errorHandler(response.data.errors);
	}
	viewUserProfile();
	Auth.setExperience(credentials.experience);
	return response;
};

export const addStoryContent = async (credentials) => {
	const response = await axios.put(`${API_MAP.AddStoryContent}`, credentials);
	return response;
};

export const saveWeddingInvite = async (credentials, config) => {
	const response = await axios.post(
		`${API_MAP.saveInvite}`,
		credentials,
		config
	);
	return response;
};

export const sendWeddingInvite = async (credentials) => {
	const response = await axios.post(`${API_MAP.sendInvite}`, credentials);
	return response;
};

export const viewWeddingInvites = async () => {
	const response = await axios.get(`${API_MAP.viewAllInvites}`);
	return response;
};

export const deleteWeddingInvite = async (credentials) => {
	const response = await axios.delete(
		`${API_MAP.deleteInvite}?id=${credentials}`
	);
	return response;
};

export const editWedding = async (credentials) => {
	const response = await axios.put(`${API_MAP.editWedding}`, credentials);
	return response;
};

export const searchWedding = async ({ searchQuery }) => {
	// console.log("query", searchQuery);
	const response = await axios.get(
		`${API_MAP.searchWedding}?search=${searchQuery}`
	);
	return response.data;
};

export const fetchSingleWeddingPhoto = async ({
	weddingId,
	albumId,
	eventCode,
}) => {
	const response = await axios.get(
		`${API_MAP.viewSingleWeddingPhoto}?weddingId=${
			weddingId || ""
		}&albumId=${albumId || "8"}&event_code=${eventCode || ""}`
	);
	return response.data;
};

export const fetchUpcomingWeddings = async () => {
	try {
		const response = await axios.get(`${API_MAP.viewUpcomingWeddings}`);
		const { hasError } = response.data;
		if (hasError) {
			return;
		}
		return response.data.data;
	} catch (error) {
		console.log("the fetch upcoming wedding error");
	}
};

export const enterWeddingEvent = async ({ data }) => {
	const response = await axios.post(`${API_MAP.enterWedding}`, data);
	return response.data;
};
